import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditAdditionalRequirements() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/AdditionalRequirementsLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Additional Requirements"
      alert="Additional Requirements Edited Successfully"
      editDataAPIEndPoint={`/AdditionalRe/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/AdditionalRe/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Additional Requirement",
              name: "ARL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "ARL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        ARL_Name: {
          required: true,
          
        },
        ARL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditAdditionalRequirements;
